import { cache } from 'swr';

export const getCacheKey = (value: string) => {
  const keys = [...cache.keys()].reverse();
  return keys.find((key) => key.includes(value) && !key.startsWith('err@'));
};
